<template>
  <div
    class="floating-top"
    :class="{ on: isVisible }"
    :style="{ bottom: bottomPosition + 'px' }"
    @click="scrollToTop"
  >
    <img src="/assets/images/icon/icon-top-button.svg" alt="Scroll to top" />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  initialBottom: {
    type: Number,
    default: 10,
  },
  isIndexView: {
    type: Boolean,
    default: false,
  },
})

const isVisible = ref(false)
const bottomPosition = ref(props.initialBottom)

const handleScroll = () => {
  const scrollValue = window.scrollY
  const windowHeight = window.innerHeight
  const footer = document.getElementById('footer')
  const section2 = document.getElementById('section_2')
  //   const floating = document.querySelector('.floating')

  // 스크롤 버튼 표시 여부 결정
  if (section2) {
    const el = section2.offsetTop
    isVisible.value = scrollValue > el
  } else {
    isVisible.value = scrollValue > 980
  }

  // footer와의 거리 계산
  if (footer) {
    const footerRect = footer.getBoundingClientRect()
    const footerTop = footerRect.top
    const defaultBottom = props.initialBottom

    if (props.isIndexView) {
      // footer가 viewport에 들어오면 버튼을 footer 위에 고정
      if (footerTop <= windowHeight) {
        bottomPosition.value = windowHeight - footerTop + 10 // footer 위 10px에 고정
      } else {
        bottomPosition.value = defaultBottom + 10
      }
    } else {
      // 다른 뷰에서의 처리
      // eslint-disable-next-line no-lonely-if
      if (footerTop <= windowHeight) {
        bottomPosition.value = windowHeight - footerTop // footer 위 10px에 고정
      } else {
        bottomPosition.value = defaultBottom
      }
    }
  }
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
  window.addEventListener('resize', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  window.removeEventListener('resize', handleScroll)
})
</script>

<style scoped>
.floating-top {
  position: fixed;
  right: 40px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  z-index: 9997; /* floating 영역의 z-index보다 2개 낮음*/
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease,
    bottom 0.3s ease; /* bottom 속성에 대한 transition 추가 */
}

.floating-top.on {
  opacity: 1;
  visibility: visible;
}

.floating-top img {
  width: 50px;
  height: 50px;
}
</style>
